import { useCallback, useState, useEffect } from "react";
import { FormikSelectField } from "src/components/FormikComponents/FormikWrappers";
import { ISelectFieldProps } from "src/components/FormikComponents/SelectField";
import { getCrewGroups } from "src/redux/actions/CrewSchedule/CrewSchedule.Actions";
import { formatFunction, parseFunction } from "./helpers";

interface ICrewGroupSelectFieldProps extends Omit<ISelectFieldProps, "options"> {
  mosaicPane: HTMLElement;
  valueKey?: string; // valueKey sent back as value - use entire object otherwise.
}

// SelectField must contain value label at a minimum
interface IGroupOption {
  label: string;
  value: string;
}

/**
 * Sepcialized wrapper for "built-in" oc crew groups select field.
 * @param props -
 */
export const CrewGroupSelectField = (props: ICrewGroupSelectFieldProps): JSX.Element => {
  const { mosaicPane, label, name, onChange, isMulti, ...selectProps } = props;

  //const mosaicPane = useMemo(() => {
  //  return id ? document.getElementById(`${id}-panel`) : null;
  //}, [id]);

  ////////////////////////////
  // MANAGE CREW GROUP LIST
  ////////////////////////////
  const valueKey = "value"; // Define valueKey here since we're creating the option object.
  const [crewGroups, setCrewGroups] = useState<IGroupOption[]>([]);

  // Get the available crew groups upon render
  useEffect(() => {
    getCrewGroups()
      .then((data: string[]) => {
        const options: IGroupOption[] =
          data?.length > 0 ? data.map((group: string) => ({ label: group, value: group })) : [];
        setCrewGroups(options ?? []);
      })
      .catch(() => setCrewGroups([]));
  }, []);

  // Setup Format And Parse functions (used if valueKey is passed)
  const formatValue = useCallback(
    (value: string) => formatFunction(value, crewGroups, valueKey, isMulti),
    [crewGroups, valueKey, isMulti]
  );
  const parseOption = useCallback((option: string) => parseFunction(option, valueKey, isMulti), [valueKey, isMulti]);

  return (
    <FormikSelectField
      name={name}
      label={label ?? "Crew Groups"}
      isMulti={isMulti}
      options={crewGroups}
      format={(value) => (valueKey ? formatValue(value) : value)}
      parse={(option) => (valueKey ? parseOption(option) : option)}
      onChange={(value: any) => !!onChange && onChange(value)}
      menuPortalTarget={mosaicPane}
      menuPosition={mosaicPane ? "fixed" : undefined}
      placeholder={`Select Crew Group${isMulti && "s"}`}
      isSearchable={true}
      isClearable={true}
      {...selectProps} // override with any props passed in such as isMulti, format, parse.
    />
  );
};
